<template>
  <ClickToJump :message="$t('pc_biz_ote_click_to_lib' /* 好的,正在为您唤起导入试题页面 */)" :target-url="targetUrl" :datas="datas" />
</template>
 
<script>
import ClickToJump from '../common/click-to-jump.vue';
import CommonMixin from '../common/props-mixin.js';

export default {
  name: 'ImportQues',
  components: {
    ClickToJump
  },
  mixins: [CommonMixin],
  data() {
    return {
      targetUrl: `${window.location.origin}/ote/#/queslib/mgmt`
    };
  }
};
</script>